import { Link } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";
import AvidaLogo from "@/components/brand/AvidaLogo";

/**
 * NotFound — 404 fallback for unknown routes.
 *
 * Renders when React Router doesn't match any registered <Route>. Without
 * this, unknown paths (including legacy bookmarks like /agency-branding
 * which is now /settings/brand) silently mount nothing and show a blank
 * page — bad UX for coordinators clicking stale links.
 */
export default function NotFound() {
  return (
    <main
      className="min-h-screen bg-paper flex flex-col items-center justify-center px-6"
      data-testid="not-found-page"
    >
      <div className="max-w-md w-full text-center">
        <div className="mb-8 flex justify-center">
          <AvidaLogo iconOnly className="w-16 h-16" />
        </div>
        <div className="text-[11px] uppercase tracking-[0.18em] text-[#3A5275] font-semibold mb-2">
          Avida PA Wizard
        </div>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-[#0B1E3A] tracking-tight mb-4">
          Page not found
        </h1>
        <p className="text-[#3A5275] text-base mb-8 leading-relaxed">
          We couldn&apos;t find the page you&apos;re looking for. It may have
          been moved or the link is out of date.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="btn-primary inline-flex items-center justify-center gap-2"
            data-testid="not-found-home-btn"
          >
            <Home className="w-4 h-4" /> Back to home
          </Link>
          <button
            type="button"
            onClick={() => window.history.back()}
            className="btn-ghost inline-flex items-center justify-center gap-2"
            data-testid="not-found-back-btn"
          >
            <ArrowLeft className="w-4 h-4" /> Go back
          </button>
        </div>
      </div>
    </main>
  );
}
